import React from "react";
import styled from "styled-components";
import bgImg from "../assets/img/titan.JPG";

const Section = styled.section`
  position: relative;
  padding-top: 138px;
  padding-bottom: 288px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-image: url(${bgImg});

  &:after,
  &:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    bottom: -1px;
    border-bottom: 10px solid #fff;
    z-index: 2;
  }

  &:before {
    left: 0;
    border-right: 12px solid transparent;
    border-left: calc(50vw - 12px) solid #fff;
  }

  &:after {
    right: 0;
    border-left: 12px solid transparent;
    border-right: calc(50vw - 12px) solid #fff;
  }

  @media (min-width: 992px) {
    padding-left: 110px;
    padding-right: 110px;
    padding-top: 279px;
    padding-bottom: 111px;
  }

  .container {
    z-index: 1;
    user-select: none;
    cursor: default;
  }
`;
// background: linear-gradient(33deg, #8400ff, #413bff);
// ackground-image: linear-gradient(62deg, #8400ff, #413bff);
const BgOverlay = styled.div`
  background: linear-gradient(33deg, #b9a1cf, #797980);
  opacity: 0.3;
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0%;
  bottom: 0%;
  left: 0%;
  top: 0%;

  @media (min-width: 992px) {
    background-image: linear-gradient(62deg, #8400ff, #413bff);
  }
`;


const HomeTitle = styled.h1`
  font-weight: 600;
  text-align: center;
  color: #f0c20a;
  font-size: 32px;
  line-height: 1.55;
  margin-bottom: 23px;
  margin-top:700px;


  @media (min-width: 992px) {
    font-size: 38px;
    line-height: 1.39;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
  }
`;

const SubTitle = styled.h5`
  font-size: 20px;
  font-weight: normal;
  line-height: 5.83;
  text-align: center;
  color: yellow;

  @media (min-width: 992px) {
    max-width: 385px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 49px;
  }
`;

const Box = styled.div`
  width: 105px;
  height: 105px;
  border: 15px solid #fb434b;
  margin-left: auto;
  margin-right: auto;
  position: relative;
`;

const Home = () => {
  return (
    <Section id="home">
      <BgOverlay />
      <div className="container">
        <div style={{backgroundColor:'black', opacity:0.7}}>
        <HomeTitle data-aos="zoom-in">
          Safe, Resilient and Efficient Transportation-Infrastructure Systems 
          Driven by Big Data Analytics, Machine Learning and Artificial Intelligence. 
        </HomeTitle>
        </div>
        <SubTitle
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-delay="400"
        >
        </SubTitle>
      </div>
    </Section>
  );
};

export default Home;
